var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckboxTick = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2299 3.73974C9.37361 3.59064 9.61105 3.58629 9.76018 3.72998C9.90928 3.87368 9.91363 4.11112 9.76994 4.26025L5.434 8.76025C5.36331 8.83358 5.26584 8.87501 5.16399 8.875C5.06206 8.87495 4.96462 8.83322 4.89397 8.75976L2.72941 6.50976C2.58606 6.36048 2.59096 6.12299 2.74016 5.97949C2.88944 5.83613 3.12693 5.84103 3.27043 5.99023L5.16399 7.95898L9.2299 3.73974Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckboxTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Checkbox Tick.0e153fcd.svg";
export { ForwardRef as ReactComponent };